import K from "./constants";
import restHelpers from "../helpers/restHelper";
const creditCardApiUrl = host => `https://${host}/v1/payment-methods/credit-cards`;

const url = (callback) => restHelpers.withBearer.get(`${K.API_URL}/api/v1/zuora/apiUrl`, {}).then(uri => callback(uri.rest));

const auth = accountKey => uri => restHelpers.withBearer
  .post(`${K.API_URL}/api/v1/zuora/paymentkeys/apiAuth`, { data: { method: 'POST', uri, accountKey } })
  .then(auth => { return { uri, auth } });

const getZuoraToken = pageId => restHelpers.withBearer.post(`${K.API_URL}/api/v1/zuora/paymentkeys`, { data: { method: 'POST', pageId } });

const setPaymentMethodDefault = (customerId, refId) => restHelpers.withBearer.post(`${K.API_URL}/api/v1/zuora/default-payment-method`, {data: { customerId, refId }});

const authHeaders = (auth) => {
  let headers = new Headers();
  headers.append('token', auth.token);
  headers.append('signature', auth.signature);
  return headers;
}

const creditCard = ({ accountKey, data }) =>
  url(creditCardApiUrl)
    .then(auth(accountKey))
    .then(({ uri, auth }) => {
      return restHelpers.post(uri, { data: Object.assign({}, data, { accountKey }), headers: authHeaders(auth) })
    })

const viewAttachments = accountKey =>
  restHelpers.withBearer.get(`${K.API_URL}/api/v2/zuora/attachments/${accountKey}`, {})

const deleteAttachment = attachmentId =>
  restHelpers.withBearer.delete(`${K.API_URL}/api/v2/zuora/attachments/${attachmentId}`, {})

export default { creditCard, viewAttachments, deleteAttachment, getZuoraToken, setPaymentMethodDefault };



// WEBPACK FOOTER //
// ./src/services/zuora.js